import React from 'react';
import { RadioGroup } from '@origo/origo-ui';
import {
    DIRECTION_POLICY_HELP,
    DIRECTION_POLICY_LABEL,
    SyncDirectionPolicy,
} from '../../api/types';
import styles from '../common/panel.module.css';

const POLICIES: SyncDirectionPolicy[] = [
    SyncDirectionPolicy.AgolToCentralOnly,
    SyncDirectionPolicy.CentralToAgolOnly,
    SyncDirectionPolicy.Both,
];

interface DirectionPolicyFieldProps {
    /** null = ikke valgt ennå. Bevisst ingen default ved opprettelse. */
    value: SyncDirectionPolicy | null;
    onChange: (policy: SyncDirectionPolicy) => void;
    name: string;
    disabled?: boolean;
}

/** Retningsvalg for en kobling, med forklaring av valgt alternativ. */
export const DirectionPolicyField: React.FC<DirectionPolicyFieldProps> = ({ value, onChange, name, disabled }) => (
    <div>
        <RadioGroup
            legend="Synkroniseringsretning"
            name={name}
            disabled={disabled}
            value={value != null ? String(value) : ''}
            onChange={(v) => onChange(Number(v) as SyncDirectionPolicy)}
            options={POLICIES.map((p) => ({ value: String(p), label: DIRECTION_POLICY_LABEL[p] }))}
        />
        <p className={styles.hint}>
            {value != null
                ? DIRECTION_POLICY_HELP[value]
                : 'Velg retning. Synk i andre retninger blokkeres, også ved «Synk alle aktiverte».'}
        </p>
    </div>
);
